// extracted by mini-css-extract-plugin
export default {"main":"main--kG2ef","root":"root--K5d_H"};